export interface Config {
  AuthAuthority: string;
  AuthClientId: string;
  AuthSignoutUrl: string;
  Hostname: string;
  ServerUrl: string;
  TenantId: string;
}

export function getConfig(): Config {
  return {
    AuthAuthority: process.env.REACT_APP_AUTH_AUTHORITY!,
    AuthClientId: process.env.REACT_APP_AUTH_CLIENT_ID!,
    AuthSignoutUrl: process.env.REACT_APP_AUTH_SIGNOUT_RETURN_URL!,
    Hostname: process.env.REACT_APP_HOSTNAME!,
    ServerUrl: process.env.REACT_APP_SERVER_URL!,
    TenantId: process.env.REACT_APP_TENANT_ID!
  };
}
